export const PAYMENT_DIRECTION_DEPOSIT = 'deposit';
export const PAYMENT_DIRECTION_WITHDRAWAL = 'withdrawal';


export const signedPaymentAmount = (rawAmount, direction) => {
  if (rawAmount === '' || rawAmount === null || rawAmount === undefined) {
    return Number.NaN;
  }

  const parsed = Number.parseFloat(rawAmount);
  if (Number.isNaN(parsed)) return Number.NaN;

  const absolute = Math.abs(parsed);
  return direction === PAYMENT_DIRECTION_WITHDRAWAL ? -absolute : absolute;
};
